export const TITLE_PROFILE_MAP: Record<string, string> = {
  'Sr Processor': 'Processing Director',
  'Loan Associate': 'Loan Associate',
  'IT Team Member': 'ActiveLink, Inc. - IT',
  'Jr Processor': 'Loan Processor',
  'Team Lead': 'Team Lead',
  'Division Lead': 'Division Lead',
  'Training Team': 'Loan Associate - Trainer',
  'Human Resources': 'HR Team',
  Admin: 'ActiveLink, Inc. - IT',
  'Doc Specialist': 'Loan Processor',
  'Loan Officer': 'Loan Associate',
}

export interface OnboardingData {
  // Identity
  firstName: string
  lastName: string
  alias: string
  username: string
  email: string

  // Role & Profile
  title: string
  profile: string
  role: string

  // Organization
  divisionLead: string
  teamLead: string
  teamLeadAssistant: string
  branch: string

  // Contact
  phone: string
  mobile: string

  // Additional Settings
  hasNMLS: boolean
  nmlsNumber: string
  lendingPadUserId: string
  enhancedNoteRole: string

  // States Licensed
  statesLicensed: string[]

  // Skills & Operational
  leadSkills: string[]
  eligiblePullStages: string[]
  loanAmountRange: string[]
  team: string
  applicationLink: string
  ultimateMaxLeads: number | ''

  // Call Center & Groups
  callCenter: string
  publicGroups: string[]

  // Loan Type Capacities
  loanTypeCapacities: Record<string, { dailyMaxLeads: number; active: boolean }>

  // Package Licenses
  packageLicenses: string[]

  // Permission Sets
  permissionSets: string[]
}

export const initialOnboardingData: OnboardingData = {
  firstName: '',
  lastName: '',
  alias: '',
  username: '',
  email: '',
  title: '',
  profile: '',
  role: '',
  divisionLead: '',
  teamLead: '',
  teamLeadAssistant: '',
  branch: '',
  phone: '',
  mobile: '',
  hasNMLS: false,
  nmlsNumber: '',
  lendingPadUserId: '',
  enhancedNoteRole: '',
  statesLicensed: [],
  leadSkills: [],
  eligiblePullStages: [],
  loanAmountRange: [],
  team: '',
  applicationLink: '',
  ultimateMaxLeads: '',
  callCenter: '',
  publicGroups: [],
  loanTypeCapacities: {},
  packageLicenses: [],
  permissionSets: ['Sales User'],
}

export interface StepProps {
  data: OnboardingData
  updateData: (updates: Partial<OnboardingData>) => void
  setCanAdvance: (canAdvance: boolean) => void
}
